import React, { useState, useEffect } from "react";
import Footer from '../Footer/Footer';
import AxiosInstance from '../Axios'
import { Container, Grid, Typography, Paper, Box } from '@mui/material';
import NotFound from '../404/NotFound';
import Loading from '../Misc/Loading';


const ServiceTerm = () => {
    const [contentData, setContentData] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchOfficeLocation = async () => {
            try {
                const response = await AxiosInstance.get(`api/serviceterm/`);
                if (response.data) {
                    setContentData(response.data);
                } else {
                    setError(true);
                }
            } catch (err) {
                setError(true);
            } finally {
                setLoading(false);
            }
        };

        fetchOfficeLocation();
    }, []);

    if (error) {
        return <NotFound />;
    }

    return (
        <>
            {loading ?
                <Loading /> :
                <>
                    <section id="service-term-section" style={{ paddingTop: '64px' }}>
                        <Container sx={{ py: { xs: 2, sm: 4 } }}>
                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                                                        <Box sx={{ textAlign: 'center', mb: { xs: 3, sm: 5 } }}>
                                                                            <Typography component="h2" variant="h4" className="standard-heading" sx={{ fontWeight: 700, color: '#0F172A', mb: 2 }}>
                                                                                Terms and Conditions
                                                                            </Typography>
                                                                        </Box>
                                    <Box sx={{ textAlign: 'center', mb: { xs: 3, sm: 5 } }}>
                                        <Typography component="h2" variant="h4" className="standard-heading" sx={{ fontWeight: 700, color: '#0F172A', mb: 2 }}>
                                        Terms and Conditions
                                        </Typography>
                                    </Box>
                                    <Paper elevation={0}>
                                        <Grid sx={{my: 1}}>
                                            <Typography
                                                variant="body1"
                                                sx={{
                                                    '& p': {
                                                        margin: 0, // Remove margin from p tags
                                                        padding: 0, // Remove padding from p tags
                                                    },
                                                }}
                                                dangerouslySetInnerHTML={{ __html: `${contentData.term}` }}
                                            />
                                        </Grid>
                                        <Grid sx={{my: 2}}>
                                            <Typography
                                                variant="body1"
                                                sx={{
                                                    '& p': {
                                                        margin: 0, // Remove margin from p tags
                                                        padding: 0, // Remove padding from p tags
                                                    },
                                                }}
                                                dangerouslySetInnerHTML={{ __html: `${contentData.agreement_offer}` }}
                                            />
                                        </Grid>
                                        <Grid sx={{my: 2}}>
                                            <Typography
                                                variant="body1"
                                                sx={{
                                                    '& p': {
                                                        margin: 0, // Remove margin from p tags
                                                        padding: 0, // Remove padding from p tags
                                                    },
                                                }}
                                                dangerouslySetInnerHTML={{ __html: `${contentData.data_transfer}` }}
                                            />
                                        </Grid>
                                        <Grid sx={{my: 2}}>
                                            <Typography
                                                variant="body1"
                                                sx={{
                                                    '& p': {
                                                        margin: 0, // Remove margin from p tags
                                                        padding: 0, // Remove padding from p tags
                                                    },
                                                }}
                                                dangerouslySetInnerHTML={{ __html: `${contentData.charge_invoice}` }}
                                            />
                                        </Grid>
                                        <Grid sx={{my: 2}}>
                                            <Typography
                                                variant="body1"
                                                sx={{
                                                    '& p': {
                                                        margin: 0, // Remove margin from p tags
                                                        padding: 0, // Remove padding from p tags
                                                    },
                                                }}
                                                dangerouslySetInnerHTML={{ __html: `${contentData.government_law}` }}
                                            />
                                        </Grid>
                                    </Paper>
                                </Grid>
                            </Grid>

                        </Container>
                    </section>
                    <Footer />
                </>
            }
        </>

    );
}

export default ServiceTerm
